import {
  Barcode,
  BookUser,
  Boxes,
  Coins,
  FilePlus2,
  FileText,
  FileWarning,
  FileX,
  Gauge,
  Landmark,
  ListTree,
  type LucideIcon,
  PackagePlus,
  Settings,
  UserPlus,
} from 'lucide-react'

export interface ShellItem {
  id: string
  label: string
  href: string
  icon: LucideIcon
  feature?: string
  keywords?: string
}

/** Cíle navigace pro příkazovou paletu. */
export const navTargets: ShellItem[] = [
  { id: 'dashboard', label: 'Přehled', href: '/', icon: Gauge, keywords: 'dashboard prehled grafy' },
  { id: 'invoices', label: 'Faktury', href: '/invoices', icon: FileText, keywords: 'faktury doklady' },
  { id: 'orders', label: 'Výzvy k platbě', href: '/orders', icon: FileWarning, keywords: 'vyzvy zalohy' },
  { id: 'expenses', label: 'Náklady', href: '/expenses', icon: FileX, keywords: 'naklady vydaje uctenky' },
  { id: 'contacts', label: 'Kontakty', href: '/contacts', icon: BookUser, keywords: 'kontakty odberatele dodavatele adresar' },
  { id: 'bank', label: 'Banka', href: '/bank', icon: Landmark, feature: 'bank', keywords: 'banka ucty transakce' },
  { id: 'cash', label: 'Pokladna', href: '/cash-register', icon: Coins, feature: 'cashRegistry', keywords: 'pokladna uctenky pos' },
  { id: 'categories', label: 'Kategorie', href: '/catalog/categories', icon: ListTree, feature: 'catalog', keywords: 'katalog kategorie' },
  { id: 'products', label: 'Produkty', href: '/catalog/products', icon: Barcode, feature: 'catalog', keywords: 'katalog produkty varianty' },
  { id: 'warehouses', label: 'Sklady', href: '/warehouse/warehouses', icon: Boxes, feature: 'warehouse', keywords: 'sklad zasoby' },
  { id: 'settings', label: 'Nastavení', href: '/settings', icon: Settings, keywords: 'nastaveni ucet' },
]

/** Položky menu Vytvořit a akce v paletě. */
export const createTargets: ShellItem[] = [
  { id: 'invoice', label: 'Faktura', href: '/invoice/new', icon: FilePlus2, keywords: 'nova faktura vystavit' },
  { id: 'order', label: 'Výzva k platbě', href: '/order/new', icon: FileWarning, keywords: 'nova vyzva' },
  { id: 'expense', label: 'Náklad', href: '/expense/upload', icon: FileX, keywords: 'novy naklad nahrat doklad' },
  { id: 'participant', label: 'Kontakt', href: '/contact/new', icon: UserPlus, keywords: 'novy kontakt' },
  { id: 'product', label: 'Produkt', href: '/catalog/product/new', icon: PackagePlus, feature: 'catalog', keywords: 'novy produkt' },
]
